import { Map } from 'immutable';

import * as types from './types';
import { GET_TEST_TRENDS, GET_TEST_HEALTH, GET_PAST_HEALTH } from '../test-overview/types';
import { MetricsRecord } from './../../records';
import {
  clearSelectedVersion,
  getInitAggregatedNames,
  parseAggregatedMetrics,
} from './utils';

export const getInitialState = () => (
  Map({
    selectedVersion: Map({
      title: null,
      items: [],
      index: 0, // used to refresh the pagination if a selected item is changed
    }),
    aggregatedNames: getInitAggregatedNames(),
    loadingTestHealth: false,
    testHealth: Map({
      totalCases: new MetricsRecord({
        name: 'Total Cases',
      }),
      totalCasesLimited: new MetricsRecord({
        name: 'Total Cases Limited',
      }),
      failing: new MetricsRecord({
        name: 'Consistently Failing',
      }),
      passing: new MetricsRecord({
        name: 'Consistently Passing',
      }),
      errored: new MetricsRecord({
        name: 'Consistently Errored',
      }),
      missingStatus: new MetricsRecord({
        name: 'Missing Status',
      }),
    }),
  })
);

const initialState = getInitialState();

const testSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_TEST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        clearSelectedVersion(newState);
        parseAggregatedMetrics(newState, payload.metrics);
      });
    case types.SELECT_BY_VERSION:
      return state.set('selectedVersion', Map(payload));
    case types.CLEAR_SELECT_BY_VERSION:
      return clearSelectedVersion(state);
    case GET_TEST_HEALTH.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('loadingTestHealth', true)
          .set('testHealth', initialState.get('testHealth'));
      });
    case GET_TEST_HEALTH.SUCCESS:
      return state.withMutations((newState) => {
        newState.setIn(['testHealth', 'totalCases', 'value'], payload.total_test_cases);
        newState.setIn(['testHealth', 'totalCasesLimited', 'value'], payload.total_test_cases_limited);
        newState.setIn(['testHealth', 'failing', 'value'], payload.consistently_failing);
        newState.setIn(['testHealth', 'passing', 'value'], payload.consistently_passing);
        newState.setIn(['testHealth', 'errored', 'value'], payload.consistently_errored);
        newState.setIn(['testHealth', 'missingStatus', 'value'], payload.consistently_complete);
        newState.set('loadingTestHealth', false);
      });
    case GET_TEST_HEALTH.FAILURE:
      return state.set('loadingTestHealth', false);
    case GET_PAST_HEALTH.SUCCESS:
      return state.withMutations((newState) => {
        newState.setIn(['testHealth', 'totalCases', 'previousValue'], payload.total_test_cases);
        newState.setIn(['testHealth', 'totalCasesLimited', 'previousValue'], payload.total_test_cases_limited);
        newState.setIn(['testHealth', 'failing', 'previousValue'], payload.consistently_failing);
        newState.setIn(['testHealth', 'passing', 'previousValue'], payload.consistently_passing);
        newState.setIn(['testHealth', 'errored', 'previousValue'], payload.consistently_errored);
        newState.setIn(['testHealth', 'missingStatus', 'previousValue'], payload.consistently_complete);
      });
    case types.CLEANUP_TEST_SUMMARY:
      return initialState;
    default:
      return state;
  }
};

export default testSummaryReducer;
export { initialState };
